import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {CommonModule, DatePipe} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';

import {
  SmdDataTable,
  SmdDatatableHeader,
  SmdDataTableRowComponent,
  SmdPaginatorComponent,
} from './';
import {ResourceService} from '../../resource/resource.service';
import {LayoutService} from '../../layout/layout.service';
import {DatatableMultivalueDialogComponent} from './smd-datatable/datatable-multivalue-dialog.component';
import {LanguageModule} from '../../language/language.module';
import {PipesModule} from '../pipes/pipes.module';
import {SmdFilter} from './smd-parts/smd-filter.component';
import {SmdTimeline} from './smd-timeline/timeline.component';
import {SmdTimelineRowComponent} from './smd-timeline/timeline-row.component';
import {TimeAgoModule} from './smd-timeline/TimeAgoModule';
import {SharedControlsModule} from '../controls/controls.module';
import {MatTreeModule} from '@angular/material/tree';
import {WorkflowTableComponent} from './smd-timeline/workflow-table.component';
import {ChildrequestTableComponent} from './smd-timeline/childrequest-table.component';
import {
  AppDialogComponent,
  AppDialogSubtitleDirective,
  AppDialogTitleDirective,
} from '../dialog/app-dialog.component';

let COMPONENTS = [
  SmdDataTable,
  SmdTimeline,
  SmdDatatableHeader,
  SmdDataTableRowComponent,
  SmdTimelineRowComponent,
  SmdPaginatorComponent,
  DatatableMultivalueDialogComponent,
  WorkflowTableComponent,
  ChildrequestTableComponent,
];

let IMPORTS = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  LanguageModule,
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatStepperModule,
  TimeAgoModule,
  SharedControlsModule,
  SmdFilter,
];

@NgModule({
  imports: [
    IMPORTS,
    PipesModule,
    MatTreeModule,
    AppDialogComponent,
    AppDialogSubtitleDirective,
    AppDialogTitleDirective,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  providers: [
    ResourceService,
    LayoutService,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule {
  static forRoot(...imports: any[]): any[] {
    return [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      MatAutocompleteModule,
      MatButtonModule,
      MatButtonToggleModule,
      MatCardModule,
      MatCheckboxModule,
      MatChipsModule,
      MatDatepickerModule,
      MatDialogModule,
      MatExpansionModule,
      MatGridListModule,
      MatIconModule,
      MatInputModule,
      MatListModule,
      MatMenuModule,
      MatNativeDateModule,
      MatPaginatorModule,
      MatProgressBarModule,
      MatProgressSpinnerModule,
      MatRadioModule,
      MatRippleModule,
      MatSelectModule,
      MatSidenavModule,
      MatSliderModule,
      MatSlideToggleModule,
      MatSnackBarModule,
      MatSortModule,
      MatTableModule,
      MatTabsModule,
      MatToolbarModule,
      MatTooltipModule,
      MatStepperModule,
      ComponentsModule,
      ...imports,
    ];
  }
}
